import React from 'react';

type Props = {
  className?: string;
};

const EggsRetrievedArrow = (props: Props) => {
  const { className } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fill="#FFE664"
        fillRule="nonzero"
        d="M10.65 21.906c-.125 0-.25-.062-.374-.187L.28 11.687a.901.901 0 0 1-.28-.656c0-.312.093-.562.28-.75.498-.375.997-.375 1.495 0l8.22 8.344V1.031C9.996.344 10.339 0 11.024 0c.623 0 .935.344.935 1.031v17.594l8.314-8.344c.498-.437.965-.437 1.401 0 .436.438.436.906 0 1.406L11.677 21.72c-.124.125-.218.187-.28.187-.311.125-.56.125-.747 0z"
      />
    </svg>
  );
};

export default EggsRetrievedArrow;
